export const PURCHASE='PURCHASE'
export const PURCHASE_SUCCESS='PURCHASE_SUCCESS'
export const PURCHASE_ERROR='PURCHASE_ERROR'

export const Purchase = (data) => ({
    type: PURCHASE,
    payload: data
})